import { Globe, Lock, Shield, Briefcase, ShieldCheck, Palette, Crown } from "lucide-react";

// Audience tags — control who can see a roadmap item + drive its accent colour.
export const AUD = {
    public: { l: "Public", c: "#64748B", I: Globe },
    private: { l: "Private", c: "#EF4444", I: Lock },
    founder: { l: "Founder", c: "#38BDF8", I: Crown },
    admin: { l: "Admin", c: "#9D4CDD", I: Shield },
    business: { l: "Business", c: "#22C55E", I: Briefcase },
    owner: { l: "Owner", c: "#F6C453", I: ShieldCheck },
    creation: { l: "Creation", c: "#D946EF", I: Palette },
};
export const AUD_ORDER = ["public", "private", "founder", "admin", "business", "owner", "creation"];

export const audiencesOf = (item) => {
    const a = item.audiences && item.audiences.length ? item.audiences : [item.visibility || (item.is_public ? "public" : "private")];
    return a.filter((x) => AUD[x]);
};

// Primary audience → left accent bar colour.
export const accentOf = (item) => {
    const a = audiencesOf(item);
    return AUD[a[0]]?.c || "#64748B";
};

export const SIZE_META = {
    small: { l: "Small", rank: 1 },
    medium: { l: "Medium", rank: 2 },
    large: { l: "Large", rank: 3 },
    xl: { l: "XL", rank: 4 },
};
